// extracted by mini-css-extract-plugin
export default {"Form":"form_Form__-VfaU","Form__p":"form_Form__p__AZTKg"};